import React from "react";
import { BsCrosshair, BsTrash, BsTrash3Fill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { decreaseQuantity, increaseQuantity, removeFromCart } from "../../store/cart.slice";
// import { ShoppingCart } from "@material-ui/icons";

const CartModal = () => {
  const cart = useSelector((state) => state.cart.cart);
  const dispatch = useDispatch();

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="offcanvasNavbarEmptyShoppingCart"
      aria-modal="true"
      role="dialog"
    >
      <div className="offcanvas-header justify-content-end border-0 pb-0">
        <button
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>

      <div className="offcanvas-body">
        {cart.length === 0 ? (
          <div className="text-center">
            <div className="mb-5">
              <img
                className="avatar avatar-xl avatar-4x3"
                src="./assets/img/svg/illustrations/oc-empty-cart.svg"
                alt="SVG"
              />
            </div>

            <div className="mb-5">
              <h3>Your cart is currently empty</h3>
              <p>
                Before proceed to checkout you must add some products to your
                shopping cart. You will find a lot of interesting products on
                our "Market place" page.
              </p>
            </div>

            <Link
              to={"/market-place"}
             
              // href="../demo-shop/index.html"
            >
              <div  className="btn btn-primary btn-transition rounded-pill px-6 py-3"
              data-bs-dismiss="offcanvas"
              aria-label="Close">
                Start shopping
              </div>
              
            </Link>
          </div>
        ) : (
          <div className=" ">
            <h3 className="mb-6 fw-medium text-center text-primary">
              {" "}
              Products in the cart{" "}
            </h3>
            {cart.map((item, id) => (
              <div
                className=" position-relative mb-2 rounded-2 border p-2"
                key={item.id}
                style={{ height: "" }}
              >
                <div onClick={() =>dispatch(removeFromCart(item.id))} className=" position-absolute top-5 btn btn-xs btn-ghost-danger " style={{ right: 10, cursor: "pointer" }}>

                <BsTrash size={16} className="  text-danger " />
                </div>
                <div className="d-flex align-items-center">
                  {/* <div className="col-auto">
                    <button
                      className="btn btn-danger btn-xs"
                      onClick={() => dispatch(removeFromCart(item.id))}
                    >
                      <BsTrash3Fill />
                    </button>
                  </div> */}
                  {/* <div className=" rounded-1"> */}
                  <img
                    src={item.image[0].url}
                    alt={item.name } //
                    width="40%"
                    height="80"
                    className=" rounded-2"
                  />
                  {/* </div> */}
                  <div className=" mx-2 d-flex flex-column justify-content-between ">
                    <div className="">{`${item.name.slice(0, 25)} ${item.name.length > 25 ? "..." : ""}` }</div>
                    <div className="">price : ${item.price}</div>
                    <div className=" d-flex align-items-center justify-content-center mt-2">
                      <div className="d-flex align-items-center">
                        <span
                          className="btn btn-primary btn-xs "
                          onClick={() => dispatch(decreaseQuantity(item.id))}
                        >
                          -
                        </span>
                        <span className="btn btn-info btn-xs mx-2">
                          {item.quantity}
                        </span>
                        <span
                          className="btn btn-primary btn-xs "
                          onClick={() => dispatch(increaseQuantity(item.id))}
                        >
                          +
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <Link to={"/market-place/cart"}>
            <button className=" btn btn-primary rounded-pill text-center w-100 py-3 mt-6" data-bs-dismiss="offcanvas" aria-label="Close">
              {" "}
              Go to shopping cart 
              {/* <ShoppingCart /> */}
            </button>
            </Link>
            
          </div>
        )}
      </div>
    </div>
  );
};

export default CartModal;
